export const NAME_MAX_LENGTH = 20;
export const NAME_REGEXP =
  // eslint-disable-next-line no-misleading-character-class
  /^[\p{L} \-\u02B9\u0027\u02BC\u02C8\u0301\u030D\u05F3\u2018\u2019\u2032\uA78C]*$/mu;

export const validationNameRules = {
  pattern: {
    value: NAME_REGEXP,
    message: 'validation.wrongSymbols'
  },
  maxLength: {
    value: NAME_MAX_LENGTH,
    message: 'validation.valueLongerThan20'
  }
};
